import { TaskState, TaskTypeDefinition } from '@modules/TasksModule/types';
import CustomerTaskView from '@pages/agent/InboxPage/components/CustomerTaskView/CustomerTaskView';
import { voiceTypes } from './voiceTypes';
import { TaskVoiceCard } from '@pages/agent/InboxPage/components/TaskVoiceCard';

const voiceTaskType: TaskTypeDefinition = {
  key: 'call',
  category: 'Calls',
  categoryIcon: 'phone',
  types: voiceTypes,
  taskRowComponent: TaskVoiceCard,
  taskViewComponent: CustomerTaskView,
  handleHydration: (parsedTask, hydrate) => {
    const isExternalCallAccepted =
      parsedTask._state === TaskState.Accepted && !parsedTask._isInternal;

    // set all accepted external calls to wrap up
    if (isExternalCallAccepted) {
      parsedTask._state = TaskState.WrapUp;
      parsedTask._recoveryStartedAt = Date.now();
    }

    const hydratedTask = hydrate(parsedTask);

    const isInternalAccepted =
      hydratedTask.state === TaskState.Accepted && hydratedTask.isInternal;

    // ignore any tasks that are in OFFERED state or internal calls that are accepted
    if (hydratedTask.state !== TaskState.Offered && !isInternalAccepted) {
      return hydratedTask;
    }

    // returning null to indicate that the task should be ignored
    // (e.g., internal accepted calls or tasks not in OFFERED state).
    return null;
  },
};

export default voiceTaskType;
